import { throttle } from 'lodash';

class MatchHeight
{
    constructor({ selector='.js-match-height', byRow=true } = {})
    {
        this.elements = document.querySelectorAll(selector);
        this.byRow = byRow;

        this.update();
        this.initThrottle();
    }

    update()
    {
        if (this.byRow) this.updateByRow();
        else
        {
            //wrap in array with height and top info
            const hydratedElements = Array.from(this.elements).map(el =>
            {
                //reset height
                el.style.minHeight = 'auto';

                const bb = el.getBoundingClientRect();

                return {
                    el,
                    height: bb.height,
                    top: document.body.scrollTop + bb.top
                };
            });
            this.matchElements(hydratedElements);
        }
    }

    updateByRow()
    {
        //setup queue
        this.queue = Array.from(this.elements);
        if (this.queue.length > 0) this.processQueue();
    }

    processQueue()
    {
        //wrap queue in array with height and top info
        const hydratedElements = this.queue.map((hEl, i) =>
        {
            // first time it's a array of dom elements
            // we replace the queue with the sorted hydratedElements at the end of processQueue()
            // so in the second call to processQueue the queue contains hydratedElements
            // that each hold an .el reference to the dom element in addition to dimensions info
            if (hEl.el === undefined) hEl = { el: hEl };

            //reset height
            hEl.el.style.minHeight = 'auto';

            const bb = hEl.el.getBoundingClientRect();

            return {
                el: hEl.el,
                height: bb.height,
                top: document.body.scrollTop + bb.top
            };
        });

        //sort by top position
        hydratedElements.sort((a,b) =>
        {
            return a.top - b.top;
        });

        const topToProcess = hydratedElements[0].top;
        const toProcess = hydratedElements.filter(hEl => hEl.top === topToProcess);

        this.matchElements(toProcess);

        //replace original queue with sorted hydratedElements, otherwise there will be conflicts when we splice the toProcess elements from the (unsorted) queue
        this.queue = hydratedElements;

        this.queue.splice(0, toProcess.length);
        if (this.queue.length > 0) this.processQueue();
    }

    matchElements(hydratedElements)
    {
        //determine new max height
        const maxHeightInGroup = hydratedElements.reduce((maxHeight, hEl) => Math.max(maxHeight, hEl.height), 0);

        hydratedElements.forEach((hEl) => {
            hEl.el.style.minHeight = `${Math.ceil(maxHeightInGroup)}px`;
        });
    }

    initThrottle()
    {
        const throttledUpdate = throttle(() => this.update(), 500);
        window.addEventListener('resize', throttledUpdate);
    }
}

export default MatchHeight;
